// extracted by mini-css-extract-plugin
export default {"copyButton":"copyButton_copyButton__hsWtL","copied":"copyButton_copied__FE498"};